const radii = {
	'6xl': '50px'
};

export default radii;
